<template>
  <div>
    <button class="todo-check" @click="toDoClicked()" :class="{ 'checked' : isDone }" v-if="!processing">
      <i class="fas fa-check"></i>
    </button>
    <div class="spinning-loader active" v-else></div>
  </div>
</template>

<script>
const axios = require('axios')

// endpoints
const apiChoice = process.env.VUE_APP_API_URL

export default {
  name: 'DatesList',
  props: {
    done: {
      type: String,
      default: ''
    },
    id: {
      type: Number
    },
    jwt: {
      type: String
    }
  },
  watch: {
    done: function () {
      this.setDone()
    }
  },
  data () {
    return {
      processing: false,
      isDone: ''
    }
  },
  components: {},
  created () {
    this.setDone()
  },
  mounted () {},
  computed: {},
  methods: {
    setDone () {
      // this.isDone = this.done
      this.isDone = this.done
    },
    toDoClicked () {
      this.processing = true
      let shotData = { 'done': '1' }
      if (this.isDone) {
        shotData = { 'done': '' }
      }
      axios
        .put(apiChoice + 'api/shots/' + this.id, shotData, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.jwt
          }
        })
        .then((response) => {
          this.isDone = response.data.done
          // stop loading
          this.processing = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.todo-check{
  cursor: pointer;
  width: 28px;
  height: 28px;
  background: none;
  border: solid 2px #d7d8db;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  .fa-check{
    font-size: 14px;
    display: none;
  }
  &.checked{
    background: #00ae8b;
    border-color: #00ae8b;
    .fa-check{
      color: white;
      display: block;
    }
  }
}
.spinning-loader{
  width: 28px;
  height: 28px;
  border-width: 3px;
}
// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
